import { Navigate } from "react-router-dom";
import { useAuth } from "../context/authContext";
import { roleRedirect } from "../constant/Constatnt";



const RootRedirect = () => {
  const { token, userType } = useAuth();

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  // Logged in → go to role dashboard
  return <Navigate to={roleRedirect[userType] || "/login"} replace />;
};

export default RootRedirect;
